import { Colors } from '@sigma-frontend-libs/commons'

import { icons } from '../enums'

export const isActiveIcons = {
  true: icons.check_circle_outline,
  false: icons.highlight_remove
}

export const isActiveColors = {
  true: Colors.success,
  false: Colors.error
}
